import { render, staticRenderFns } from "./departmentForm.vue?vue&type=template&id=573c5269&scoped=true&"
import script from "./departmentForm.vue?vue&type=script&lang=js&"
export * from "./departmentForm.vue?vue&type=script&lang=js&"
import style0 from "./departmentForm.vue?vue&type=style&index=0&id=573c5269&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c5269",
  null
  
)

export default component.exports